import styled from '@emotion/styled'
import {COLORS} from './constants'

/** Vertical stack wrapping the KPI summary, banner, legend and the scrollable tree. */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

/** Mobile-only hint telling the user the tree can be scrolled horizontally. */
export const ScrollHint = styled.div`
  font-size: 11px;
  color: ${COLORS.mutedText};

  @media (min-width: 960px) {
    display: none;
  }
`

/** Scroll container — both axes scroll so a wide/deep hierarchy never breaks the page layout. */
export const ScrollArea = styled.div`
  overflow: auto;
  max-height: 72vh;
  margin: 0 -4px;
  padding: 0 4px 8px;
  -webkit-overflow-scrolling: touch;
`

/** Fixed-min-width inner wrapper that drives the horizontal scroll on narrow screens. */
export const TreeInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 720px;
`

/** Placeholder card shown when the viewer has no PAMM offers to display. */
export const EmptyState = styled.div`
  padding: 40px 16px;
  text-align: center;
  font-size: 14px;
  color: ${COLORS.mutedText};
  border: 1px dashed ${COLORS.border};
  border-radius: 12px;
  background-color: ${COLORS.mutedBg};
`
